import { Component, OnInit, Input, ElementRef, ViewChild, AfterViewInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { saveAs } from "file-saver";
import Swal from "sweetalert2"; 
import { DatePipe, getLocaleDateFormat } from "@angular/common"; 
 import * as XLSX from "xlsx";
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { debounce, filter } from 'rxjs/operators';
import { Router } from '@angular/router'; 
import { Company } from "../modulos/seguridad/models/company.model";
import { Documento_CPE } from "../models/Documento_CPE.models";
import { EntradasService } from "../modulos/entradas/services/entradas.service";
import { EstadoDocumentoComponent } from "../modulos/entradas/pages/entradas/modals/estado_factura/estado-documento.component";
import { ObservacionesComponent } from "../modulos/entradas/pages/entradas/modals/observaciones/observaciones.component";
import { EnvioCorreoComponent } from "../modulos/entradas/pages/entradas/modals/envio-correo/envio-correo.component";
import { NuevoRegistroComponent } from "../modulos/entradas/pages/entradas/modals/nuevo-registro.component";
import { SubirArchivoComponent } from "../modulos/entradas/pages/entradas/modals/subir-archivo/subir-archivo.component";
import { ConfirmarFacturaDetalleComponent } from "../modulos/entradas/pages/entradas/modals/facturaImportacion/confirmar-factura-detalle.component";

@Component({
  standalone: false,
  selector: "app-entradascliente",
  // templateUrl: '<app-nuevo-registro2 (DocuLis) = display($event)><app-nuevo-registro2>',
  templateUrl: "./entradascliente.component.html",
  styleUrls: ['./entradascliente.component.scss'],
  animations: [
    trigger('detailExpand', [
    state('collapsed', style({height: '0px', minHeight: '0', display: 'none'})),
    state('expanded', style({height: '*'})),
    transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})


export class EntradasClienteComponent implements OnInit{
  expanded: boolean = false;
  expandedElement: Documento_CPE | null;
  displayedColumns: string[] = [
    'tipo_doc',
    'documento',
    'doc_referencia',
    'proveedor',  
    'fechadocumento', 
    'total',
    'generarnotacredito', 
    'consultarestado', 
    'darbaja', 
    'reporte', 
    'enviaremail', 
    'cpe', 
    'cdr', 
    'archivo'
  ];
  displayedColumnsVersion: string[] = [
    'descripcion',
    'unidadmedida', 
    'cantidad', 
    'precio', 
    'importe'
  ];
  ColumnsExport: string[] = ['Nombre', 'Estado'];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  @ViewChild("table", {static: true}) table: ElementRef;
  constructor(
    private modalService: NgbModal,
    private entradasService: EntradasService,
    public activemodal: NgbActiveModal,
    public router: Router,
    private datePipe: DatePipe,
  ) {}

  // lsDocumentosFac: Array<any> = [];
  datosDocumento: Documento_CPE[] = [];
  lsDocumentosFac = null;  
  lsDocumentosFacExcel = null;
  // lsDocumentosFac = new MatTableDataSource();
  lsDocumentosFaccopia: Array<any> = [];
  lsDocumentosBaja: Array<any> = [];
  lsDocumentosAux: Array<any> = [];
  lsFiltoFecha: Array<any> = [];
  public lstipodocumentos: Array<any> = [];
  public documento_cpe: Documento_CPE = new Documento_CPE();
  response: any;
  checkND: any;
  checkNB: any;
  tdoc: any;
  dfecha: any;
  tEstado: any;
  valIcons: boolean = false;
  valbuton: boolean = false;
  cargando: boolean = false;
  lsCheck: boolean = false;
  filterPost = "";
  mostrarCD = "";
  idlocalStorage : number
  public empresadat: Company = new Company();
 
  filterBoolean: boolean;
  lsEstadoDocumento: any = [
    {
      estado: "Rechazado",
      codigo: 0
    },
    {
      estado: "Aceptado",
      codigo: 1
    },
    {
      estado: "Anulado",
      codigo: 2
    },
    {
      estado: "Pendientes",
      codigo: 3
    }
  ];
  //listado pagina
  public cantidad_registros = 15;
  public total_documentos : number;
  pageEvent: any;
mostrar_campos:any;
progressTable: boolean = false  

  ngOnInit() {   
    this.empresadat = JSON.parse(localStorage.getItem("datempresa"));
    this.idlocalStorage = Number.parseInt(localStorage.getItem('localid'))
    let date = new Date();
    let primerDia = new Date(date.getFullYear(), date.getMonth(), 1);
    this.documento_cpe.fecha_inicio = primerDia;

    this.listarTipodocumento();
    this.checkND = document.getElementById("guia");
    this.checkAction();
    this.valButton();
      
 

    this.listarDocumento();
  }
 
  fireEvent(): void {
       let fin = this.documento_cpe.fecha_fin.setHours(23,59,59);
    let id_empresa = Number(localStorage.getItem("empresaselect"));
    let idlocal = localStorage.getItem("localid");
    var doc  = {id_empresa: id_empresa,
      "fecha_inicio" : new Date(this.documento_cpe.fecha_inicio),
      "fecha_fin" : new Date(fin),
      "cod_tipo_documento" : this.tdoc,
      "estado" : this.tEstado,
      "idlocal": idlocal
    } 

    this.entradasService.generaExcelDocumentoVenta(doc).subscribe((resp: any) => {

      var file = new Blob([resp], { type: 'application/vnd.ms-excel' });
      saveAs(file, "Documento_Venta.xlsx");
    });
}

  valButton() {
    if (this.lsDocumentosBaja.length == 0) {
      this.valbuton = false;
    } else {
      this.valbuton = true;
    }
  }
  checkAction() {
    this.filterPost = "";
    if (this.checkND!=null && this.checkND.checked!=null &&this.checkND.checked == true) {
      this.mostrarCD = "Ejemplo: xxxx-xxxxxxxxxx";
      this.filterBoolean = true;
    } else {
      this.filterBoolean = false;
    }
  }

  enviarCheck(event, id) {
    if (event == true) {
      let newDoc: any = new Object();
      newDoc.id_documento = id;
      this.lsDocumentosBaja.push(newDoc);
    } else {
        const documentIndex = this.lsDocumentosBaja.findIndex(x => x.id_documento == id);
        if (documentIndex !== -1) {
          this.lsDocumentosBaja.splice(documentIndex, 1);
        }
    }
    this.valButton();
  }

  public previsualizarDocu(docu,eve,ver_doc) {      
    this.empresadat = JSON.parse(localStorage.getItem("datempresa"));

    var documento = docu;
    const modalRef = this.modalService.open(ConfirmarFacturaDetalleComponent, {
      backdrop: "static",
      keyboard: false,
      size: "lg"
    });
    this.activemodal.close();
    modalRef.componentInstance.input_visualizar = eve;
    modalRef.componentInstance.input_documento_cpe = documento;
    modalRef.componentInstance.empresadato = this.empresadat;
    modalRef.componentInstance.boolean_previsualizacion = true;

    // modalRef.componentInstance.descripcion_produ = this.documento_cpe.detalle[0];
    modalRef.result.then(
      result => {},
      reason => {}
    );
  }

  enviarlsDoc() {
    // this.lsDocumentosBaja = this.lsDocumentosFac.filter(function(obj) {
    //   return obj.valSend == true;
    // });
    this.openModalObservaciones(null);
  }

  public cleanGuiasSeleccStorage() {
    let guiasStorage = null;
    let flag_isc = null;
    let flag_igv = null;
    let lsnewDetalls = [];
    localStorage.setItem("lsnewDetalls", JSON.stringify(lsnewDetalls));
    localStorage.setItem("guiasSeleccionadas", JSON.stringify(guiasStorage));
    localStorage.setItem("flg_isc", JSON.stringify(flag_isc));
    localStorage.setItem("flg_igv", JSON.stringify(flag_igv));
  }
  funcPaginator(event):any{         
    this.listarDocumento();
  }
  funclsDocuxfecha(){          
    // if(this.documento_cpe.fecha_fin.toString().substring(16,24)!="00:00:00"){
    //   this.listarDocumento();
    // }
    this.listarDocumento();
  }
  funclsDocuxfechaIni(){          
    // if(this.documento_cpe.fecha_inicio.toString().substring(16,24)!="00:00:00"){
    //   this.listarDocumento();
    // }
    this.listarDocumento();
  }

  public listarDocumento() {        
    this.progressTable = true
    let fin ;
    if(this.documento_cpe.fecha_fin!=null){
      fin = this.documento_cpe.fecha_fin.setHours(23,59,59);
    }

    this.cantidadDocumento();
    this.documento_cpe.cantidad_registros = this.cantidad_registros;
    this.documento_cpe.page_Index = this.paginator.pageIndex + 1;
    let id_empresa = Number(localStorage.getItem("empresaselect"));
    let idlocal = localStorage.getItem("localid");
     this.entradasService.listarDocumento({id_empresa: id_empresa,
                                          "fecha_inicio" : this.documento_cpe.fecha_inicio,
                                          "fecha_fin" : fin,
                                          "cod_tipo_documento" : this.tdoc,
                                          "estado" : this.tEstado,
                                          "can_pag":this.documento_cpe.cantidad_registros,
                                          "ind_pag":this.documento_cpe.page_Index ,
                                          "idlocal": idlocal
                                        }).subscribe(resp => {      
             this.progressTable = false

        if (resp == null) {
        } else {   
          //INYECCION DE DEPENCIA
          this.lsDocumentosFac = resp.aaData[0];
          this.lsDocumentosFacExcel = resp.aaData[1];
          this.lsDocumentosFac = new MatTableDataSource<Documento_CPE>(this.lsDocumentosFac);
          this.lsDocumentosFaccopia = [...this.lsDocumentosFac.data]; 
     
        this.lsDocumentosFac.filteredData.map((x)=>{
          x.tipo_doc=x.cod_tipo_documento;
          x.referencia="";
        });
            for(let obj of this.lsDocumentosFac.filteredData){
          if(obj.tipo_doc=="01"){
            obj.tipo_doc="Factura";
          }else if(obj.tipo_doc=="07"){
            obj.tipo_doc="Nota de credito";
            obj.referencia="doc_referencia";
            }else if(obj.tipo_doc=="08"){
            obj.tipo_doc="Nota de Debito";
            obj.referencia="doc_referencia";
            }else if(obj.tipo_doc=="03"){
            obj.tipo_doc="Boleta de Venta";
          }else if(obj.tipo_doc=="09"){
            obj.tipo_doc="Guia Remision-Remitente";
          }else{
            obj.tipo_doc="Guia Remision-Transportista";
          }
        }
        }
      });
  }
  applyFilter(event: Event) {   

    this.lsDocumentosFac.filteredData.map((x)=>{
      x.cliente_razon_social=x.clientes.razon_social;
      
    });
		const filterValue = (event.target as HTMLInputElement).value;
		this.lsDocumentosFac.filter = filterValue.trim().toLowerCase();
	
		if (this.lsDocumentosFac.paginator) {
		  this.lsDocumentosFac.paginator.firstPage();
		}
    }
  public cantidadDocumento() {
    let id_empresa = Number(localStorage.getItem("empresaselect"));
    let idlocal = localStorage.getItem("localid");
    this.entradasService.cantidadDocuemntos({ id_empresa: id_empresa,
                                              "fecha_inicio" : this.documento_cpe.fecha_inicio,
                                              "fecha_fin" : this.documento_cpe.fecha_fin,
                                              "cod_tipo_documento" : this.tdoc, 
                                              "estado" : this.tEstado,
                                              "idlocal":idlocal ,
                                            }).subscribe((resp: any) => {
        if (resp == null) {
        } else {
          this.total_documentos = resp.cantidad;
          // this.listarPorEstadoDoc(cod);
        }
      });
  }

  // public listarDocumentoOpcional(cod) {
  //   let id_empresa = Number(localStorage.getItem("empresaselect"));
  //   this.entradasService.listarDocumentoOpcional({ id_empresa: id_empresa }).subscribe((resp: any) => {
  //       if (resp == null) {
  //       } else {
  //         this.lsDocumentosAux = resp.aaData;
  //         // this.listarPorEstadoDoc(cod);
  //       }
  //     });
  // }

  

  documentoData() {
    this.entradasService.listarDocumento_cpe.subscribe(resp => {
      if (resp == null) {
      } else {
        this.datosDocumento = resp.aaData;
        this.lsDocumentosFac = new MatTableDataSource<Documento_CPE>(this.datosDocumento);
        this.lsDocumentosFac.paginator = this.paginator;
        this.lsDocumentosAux = resp.aaData;
        // this.listarPorFecha();
      }
    });
  }

  listarPorTipoDoc(cod) {         
    if (cod == null) {
      this.valIcons = false;
      if (this.tEstado != null) {
        this.listarPorEstadoDoc(this.tEstado);
      } else {
        this.listarDocumento();
      }
    } else {
      if (this.lsDocumentosFaccopia.length > 0) {
        this.lsDocumentosFac.data = [...this.lsDocumentosFaccopia];
      }
      // this.lsDocumentosFac = this.lsDocumentosAux;
      let fecha_ini = this.documento_cpe.fecha_inicio;
      let fec_fin = this.documento_cpe.fecha_fin;
      if (this.tEstado != null) {
        // con estado ,cod_tipo_doc,fechas!=null
        let x = this.tEstado;
        if (this.tEstado == 1 && this.tdoc == "03") {
          this.valIcons = true;
        } else {
          this.valIcons = false;
        }
        this.lsFiltoFecha = this.lsDocumentosFac.data.filter(function(obj) {
          return (
            obj.cod_tipo_documento == cod &&
            obj.estado == x &&
            obj.fecha_documento_aux <= fec_fin &&
            obj.fecha_documento_aux >= fecha_ini
          );
        });
      } else {
        //fechas=null && estado =null
        this.lsFiltoFecha = this.lsDocumentosFac.data.filter(function(obj) {
          return (
            obj.cod_tipo_documento == cod &&
            obj.fecha_documento_aux <= fec_fin &&
            obj.fecha_documento_aux >= fecha_ini
          );
        });
      }
      this.lsDocumentosFaccopia = [...this.lsDocumentosFac.data];
      this.lsDocumentosFac.data = this.lsFiltoFecha;
    }
  }

  // listarPorFecha() {
  //   let fecha_ini;
  //   let fec_fin;
  //   let fecha_doc;
  //   let fe_doc;

  //   if (this.lsDocumentosFaccopia.length > 0) {
  //     this.lsDocumentosFac.data = [...this.lsDocumentosFaccopia];
  //   }
  //   ///fec ini
  //   fecha_ini = this.documento_cpe.fecha_inicio;

  //   fec_fin = this.documento_cpe.fecha_fin;
  //   fec_fin = new Date(
  //     this.documento_cpe.fecha_fin.getFullYear(),
  //     this.documento_cpe.fecha_fin.getMonth(),
  //     this.documento_cpe.fecha_fin.getDate(),
  //     23,
  //     59,
  //     59
  //   );
  //   this.documento_cpe.fecha_fin = fec_fin;

  //   for (let cat of this.lsDocumentosFac.data) {
  //     fecha_doc = cat.fecha_documento;
  //     let fe_doc;
  //     fe_doc = new Date(fecha_doc);
  //     cat.fecha_documento_aux = fe_doc;
  //   }

  //   this.lsFiltoFecha = this.lsDocumentosFac.data.filter(function(cat) {
  //     return (
  //       cat.fecha_documento_aux <= fec_fin &&
  //       cat.fecha_documento_aux >= fecha_ini
  //     );
  //   });
  //   this.lsDocumentosFaccopia = [...this.lsDocumentosFac.data];
  //   this.lsDocumentosFac.data = this.lsFiltoFecha;
  // }

  listarPorEstadoDoc(cod) {         
    /*--------------------------------------------------------------------------------*/
    if (this.response != 2) {
      if (cod == null) {
        this.valIcons = false;
        if (this.tdoc != null) {
         } else {
          this.listarDocumento();
        }
      } else {
        // this.lsDocumentosFac = this.lsDocumentosAux;
        let fecha_ini = this.documento_cpe.fecha_inicio;
        let fec_fin = this.documento_cpe.fecha_fin;
        if (this.lsDocumentosFaccopia.length > 0) {
          this.lsDocumentosFac.data = [...this.lsDocumentosFaccopia];
        }
        if (this.tdoc != null) {
          let x = this.tdoc;
          if (this.tEstado == 1 && this.tdoc == "03") {
            this.valIcons = true;
          } else {
            this.valIcons = false;
          }
          this.lsFiltoFecha = this.lsDocumentosFac.data.filter(function(obj) {
            return (
              obj.estado == cod &&
              obj.cod_tipo_documento == x &&
              obj.fecha_documento_aux <= fec_fin &&
              obj.fecha_documento_aux >= fecha_ini
            );
          });
        } else {
          this.lsFiltoFecha = this.lsDocumentosFac.data.filter(function(obj) {
            return (
              obj.estado == cod &&
              obj.fecha_documento_aux <= fec_fin &&
              obj.fecha_documento_aux >= fecha_ini
            );
          });
        }
        this.lsDocumentosFaccopia = [...this.lsDocumentosFac.data];
        this.lsDocumentosFac.data = this.lsFiltoFecha;
      }
    } else {
      this.response = 0;
    }
  }

  print(doc) {
       
    const obj = {
      iddocumento: doc.id_documento,
      id_local: this.idlocalStorage,
      cod_tipo_documento: doc.cod_tipo_documento
    };
    this.cargando = true;
    this.entradasService.reportes(obj).subscribe(resp => {
      this.cargando = false;
      var file = new Blob([resp], { type: "application/pdf" });
      saveAs(file, "reportes.pdf");
    },(error:any)=>{
      this.cargando = false;
    });
  }

  public listarTipodocumento() {
    this.entradasService
      .retornaSutipodocumento({ estado: 1 })
      .subscribe(resp => {
        if (resp.estado == 1) {
          this.lstipodocumentos = resp.aaData;
        } else {
          Swal.fire(
            "Error en la transaccion => listarTipodocumento()",
            resp.msg,
            "error"
          );
        }
      });
  }

  verEstadoDocumento(documento) {
    for (let obj of this.lstipodocumentos) {
      if (obj.codigosunat === documento.cod_tipo_documento) {
        documento.descripcion_tipo_documento = obj.descripcion;
      }
    }
    const modalRef = this.modalService.open(EstadoDocumentoComponent, {
      backdrop: "static",
      keyboard: false,
      windowClass: 'modalMD'
    });
    modalRef.componentInstance.input_documento = documento;
    modalRef.result.then(
      result => {
        //close
      },
      reason => {
        //dismiss
        this.response = reason;
      }
    );
  }

  descargarDocumentoCPE(documento, tipo_comprobante) {
    this.cargando = true;

    this.entradasService
      .descargarDocumentoCPE({
        iddocumento: documento.id_documento,
        tipo_comprobante: tipo_comprobante
      })
      .subscribe((resp: any) => {
        if (resp.estado == 1) {
          this.cargando = false;
          const byteCharacters = atob(resp.file);
          let byteNumbers = [];
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          var file = new Blob([byteArray], { type: "application/xml" });
          saveAs(file, resp.file_nombre);
        } else {
          Swal.fire("Error en la transaccion", resp.msg, "error");
        }
      },(error:any)=>{this.cargando = false;
      });
  }

  openModalEstadoDocumento(documento) {
    this.verEstadoDocumento(documento);
  }
  envioCPE(doc) {
    const obj = {
      id_documento: doc.id_documento,
      id_empresa: doc.id_empresa
    };
    this.entradasService.envioCPE(obj).subscribe((resp: any) => {
    });
  }

  public openModalObservaciones(documento) {
    const modalRef = this.modalService.open(ObservacionesComponent, {
      backdrop: "static",
      keyboard: false,
      windowClass: 'modalMD'
    });
    
    this.activemodal.dismiss();
    modalRef.componentInstance.input_documento_baja = documento;
    modalRef.componentInstance.lsdocumento_baja = this.lsDocumentosBaja;

    modalRef.result.then(
      result => {
        //close
      },
      reason => {
        //dismiss
      }
    );
  }
  public openModalCorreo(documento) {
    const modalRef = this.modalService.open(EnvioCorreoComponent, {
      backdrop: "static",
      keyboard: false,
      windowClass: 'modalMD'
    });
    this.activemodal.dismiss();
    modalRef.componentInstance.input_documento_email = documento;
    modalRef.result.then(
      result => {
        //close
      },
      reason => {
        //dismiss
        documento.asunto = "";
      }
    );
  }

  public actualizarDocumento(documento) {
    if (documento.estado == 0) {
      // DECLARADO RECHAZADO
      this.entradasService
        .retornaDocumentoPorId({ id_documento: documento.id_documento })
        .subscribe((resp: any) => {
          if (resp == null) {
          } else {
            this.documento_cpe = resp.defaultObj;
            const {
              estado_pagado,
              total_detracciones,
              total_igv,
              total_isc,
              total_descuento,
              porcentaje_descuento
            } = this.documento_cpe;
            this.documento_cpe.igv = total_igv > 0 ? true : false;
            this.documento_cpe.isc = total_isc > 0 ? true : false;
            this.documento_cpe.bool_estado_pagado =
              estado_pagado == 1 ? true : false;
            this.documento_cpe.bool_detraccion =
              total_detracciones > 0 ? true : false;
            this.documento_cpe.porcentaje_descuento =
              total_descuento > 0 ? porcentaje_descuento : undefined;
            this.documento_cpe.detalle = this.documento_cpe.ls_documentoCpe;
            this.documento_cpe.detalle.forEach(e => {
              e.bool_impuesto = e.igv > 0 ? true : false;
              e.total = parseFloat((e.importe + e.igv).toFixed(2));
            });
            this.openModalActualizarDocumento();
          }
        });
    }
  }

  public openModalActualizarDocumento() {
    const modalRef = this.modalService.open(NuevoRegistroComponent, {
      backdrop: "static",
      keyboard: false,
      windowClass: 'modalMD'
    });
    modalRef.componentInstance.input_documento_cpe = this.documento_cpe;
    modalRef.result.then(
      result => {},
      reason => {}
    );
  }

  nuevoArchivo(indice) {
    this.openModal(indice);
  }

  public openModal(documento) {
    const modalRef = this.modalService.open(SubirArchivoComponent, {
      backdrop: "static",
      keyboard: false,
      windowClass: 'modalMD'
    });
    let cat: any = new Object();
    //this.activemodal.dismiss();
    cat.ruta_archivo = documento.ruta_archivo;
    cat.id_documento = documento.id_documento;
    modalRef.componentInstance.ruta_documento = cat;
    modalRef.result.then(
      result => {
        if (result?.ruta_archivo || result?.nombre_archivo) {
          documento.ruta_archivo = result.ruta_archivo || result.nombre_archivo;
        }
      },
      reason => {
        //dismiss
        documento.asunto = "";
      }
    );
  }

  botonHabilitarResumen(){
    if(this.lsCheck == false){
      this.lsCheck = true
    }else{
      this.lsCheck = false
    }
  }

}
